import {Page} from "./models/Page";
import {Comment} from "./models/Comment";
import {useReducer} from "react";
import Markdown from "react-markdown";
import rehypeExternalLinks from 'rehype-external-links'
import {ToggleName} from "./State";
import {User} from "./models/User";

export type State = {
    user: any | null
    generateds: [any]
}

export type Action = |
    { type: 'toggle', payload: ToggleName } |
    { type: 'toggle-set', payload: ToggleName, value: boolean } |
    { type: 'set-user', payload: User | null } |
    { type: 'sign-out' }
    ;

function Generateds(props: { generateds: [any], user: any }) {
    const initialState: State = {
        user: props.user,
        generateds: props.generateds
    };

    console.log("initialState", initialState);

    const reducer = (state: State, action: Action): State => {
        switch (action.type) {
        }
        return state;
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    console.log("state", state);

    return (<>
        <div className="row justify-content-sm-center align-items-center">
            <div className="col-md-12">
                <h1>Wangs</h1>
            </div>
        </div>
        {state.generateds.map((generated: any) => {
            return <>
                <div className="row justify-content-sm-center align-items-center">
                    <div className="col-md-6">
                        <img className="img-fluid" src={generated.image_url}/>
                    </div>
                    <div className="col-md-6">
                        <Markdown rehypePlugins={[[rehypeExternalLinks, {target: '_blank'}]]}>{generated.fan_markdown}</Markdown>
                    </div>
                </div>
            </>
        })}
    </>);
}


export default Generateds;
